import type { ComponentSchema } from "../../../../../schema-types"
import { primaryButtonFields, outlineButtonFields } from "../shared/button-schema-fields"

export const schema: ComponentSchema = {
  type: 'featured-category',
  label: 'Featured Category',
  description: 'Display products from a specific category.',
  supportedPages: ['home', 'product', 'cart'],
  variants: [
    {
      id: 'v1',
      label: 'V1 (Grid Layout)',
      fields: [
        { key: 'title', label: 'Title', type: 'string' },
        { key: 'subtitle', label: 'Subtitle', type: 'string' },
        { key: 'categoryId', label: 'Select Category', type: 'category-select' },
        { key: 'rows', label: 'Number of Rows', type: 'number', default: 1 },
        { key: 'noSelectionText', label: 'No Category Selected Text', type: 'string', default: 'Please select a category in the editor settings.' },
        { key: 'noProductsText', label: 'No Products Text', type: 'string', default: 'No products found in this category.' },
        { key: 'viewAllText', label: 'View All Button Text', type: 'string', default: 'View All' },
      ],
    },
  ],
  commonFields: [
    {
      key: 'productCardVariant',
      label: 'Product Card Style',
      type: 'select',
      options: [
        { label: 'Bordered (V1)', value: 'v1' },
        { label: 'Clean (V2)', value: 'v2' },
      ],
      default: 'v1',
    },

    // ─── Product Card Buttons ─────────────────────────────────────────
    ...primaryButtonFields('buttons.orderNow', 'Order Now Button'),
    ...outlineButtonFields('buttons.addToCart', 'Add to Cart Button'),
  ],
}
